import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink } from "@apollo/client";
import "antd/dist/antd.min.css";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";

import { ProductsProvider } from "./contexts/ProductsContext";
import { auth0Config } from "./config";

const uri = process.env.REACT_APP_API_ENDPOINT;
console.log("API_URL: ", uri);

const httpLink = createHttpLink({
  uri: uri,
  credentials: "include",
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <ApolloProvider client={client}>
        {/* <AuthProvider> */}
        <Auth0Provider
          domain={auth0Config.domain}
          clientId={auth0Config.clientId}
          authorizationParams={{
            redirect_uri: window.location.origin,
          }}
        >
          <ProductsProvider>
            <App />
          </ProductsProvider>
        </Auth0Provider>
        {/* </AuthProvider> */}
      </ApolloProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
